/*  ==========================================================================
    EHOTELIER OFFER FILTER
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import flatpickr from 'flatpickr';

// local imports
import * as vars from '../../globals/variables';
import * as utils from "../utils";

/*
 * EHOTELIER OFFER FILTER
 */

// initialization
export function initEhotelierOfferFilter($element,container,page,config) {
    let $filter = $element.find('.bn-offers-filter'),
        $filter_category = $filter.find('.bn-offers-filter__cat'),
        $filter_dateFrom = $filter.find('.bn-offers-filter__date--from'),
        $filter_dateTo = $filter.find('.bn-offers-filter__date--to'),
        $filter_optionOverlay = $filter.find('.bn-offers-filter__option-overlay'),
        $filter_submit = $filter.find('.bn-offers-filter__submit');

    // get to date
    let fp_to = $filter_dateTo.flatpickr({
        altFormat: 'd.m.Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        disable: [
            function() {
                return false;
            }
        ],
        minDate: 'today',
        onChange: function() {
            $(container).attr('data-date-to',$filter_dateTo.val());
        }
    });

    // get from date
    let fp_from = $filter_dateFrom.flatpickr({
        altFormat: 'd.m.Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        disable: [
            function() {
                return false;
            }
        ],
        minDate: 'today',
        onChange: function(selectedDates, dateStr, instance) {
            $(container).attr('data-date-from',$filter_dateFrom.val());

            // add right "min date" to "to date"
            fp_to.set('minDate',dateStr);

        }
    });

    // trigger flatpickr by clicking on option overlay (only on non mobile devices)
    $filter_optionOverlay.on('click', function () {
        if ($(this).hasClass('bn-offers-filter__option-overlay--from')) {
            fp_from.toggle();
        } else if ($(this).hasClass('bn-offers-filter__option-overlay--to')) {
            fp_to.toggle();
        }
    });

    // get categories
    $filter_category.on('change', function () {
        let categories = $filter.find('.bn-offers-filter__cat:checked').map(function(){return this.value;}).get();
        $(container).attr('data-category',categories);
    });

    // submit
    $filter_submit.on('click', function () {

        // reset
        page = 1;
        config.addParams.page = page;
        $(container).empty();
        $(container).removeClass('eh-service--ready');
        $(container).append(vars.default_loader);
        $(container).append(vars.default_noEntries);

        // filter after from date
        if ($(container).attr('data-date-from')) {
            let fromDate = $(container).attr('data-date-from');
            config.addParams.fromdate = fromDate;
        }

        // filter after to date
        if ($(container).attr('data-date-from')) {
            let toDate = $(container).attr('data-date-to');
            config.addParams.todate = toDate;
        }

        // filter after categories
        if ($(container).attr('data-category')) {
            let category = $(container).attr('data-category');
            config.addParams.offercategories = category;
        } else {
            config.addParams.offercategories = '';
        }

        // ehotelier service initialization
        utils.ehotelierLoader.initEhotlierService(config);

    });
}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/ehotelier-offer-filter.js